var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title",class:{ shadow: _vm.shadow }},[(!_vm.viewInfo.pageIndex)?_c('div',{staticClass:"back",on:{"click":_vm.backFn}},[_c('i',{staticClass:"el-icon-arrow-left"}),_vm._v(" 返回 ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.viewInfo.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }